import { constants, typographyStyles } from "@newsela/angelou";

const { ui } = constants.colors;
const { textMObj } = typographyStyles;

export const containerCss = {
  width: "100%",
};

export const tabsContainerCss = {
  display: "flex",
  margin: "0",
  marginBottom: "1.5rem",
  padding: "0",
  paddingBottom: "0.4rem",
  borderBottom: `1px solid ${ui.neutral[100]}`,
  button: {
    cursor: "pointer",
    padding: "2px 0",
    background: "none",
    borderTop: "none",
    borderRight: "none",
    borderLeft: "none",
  },
};

export const itemCss = {
  ...textMObj,
  height: "1.5rem",
  listStyleType: "none",
  padding: "0 1.5rem 0 0",
};

export const inactiveItemCss = {
  ...textMObj,
  color: ui.neutral[400],
  borderBottom: "none",
};

export const activeItemCss = {
  ...textMObj,
  color: ui.neutral[700],
  borderBottom: `3px solid ${ui.core[700]}`,
};
